import React from 'react';
import { Warning } from '@phosphor-icons/react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

const estadoConfig = {
  agendado: { label: 'Agendado', color: '#6C757D', bgColor: '#6C757D20' },
  en_espera_asignacion: { label: 'En Espera de Asignación', color: '#0891B2', bgColor: '#0891B220' },
  asignado: { label: 'Asignado', color: '#008630', bgColor: '#00863020' },
  realizada: { label: 'Realizada', color: '#065F46', bgColor: '#065F4620' },
  suspendida: { label: 'Suspendida', color: '#78716C', bgColor: '#78716C20' },
  aprobado: { label: 'Aprobado', color: '#C1121F', bgColor: '#C1121F20' },
  rechazado: { label: 'Rechazado', color: '#FF3B30', bgColor: '#FF3B3020' },
};

const overlap = (m1, m2) => {
  try {
    const s1 = parseISO(m1.fecha_inicio);
    const e1 = parseISO(m1.fecha_fin);
    const s2 = parseISO(m2.fecha_inicio);
    const e2 = parseISO(m2.fecha_fin);
    return s1 < e2 && s2 < e1;
  } catch {
    return false;
  }
};

const MovRow = ({ mov, hasConflictWithOther, onSelect }) => {
  const st = estadoConfig[mov.estado] || estadoConfig.agendado;
  return (
    <button
      data-testid={`calendar-day-mov-${mov.id}`}
      onClick={() => onSelect(mov)}
      className={`w-full text-left border p-4 hover:bg-[#F8F9FA] transition-colors ${
        hasConflictWithOther ? 'border-[#FF3B30]' : 'border-[#E9ECEF]'
      }`}
    >
      <div className="flex items-start justify-between gap-3 mb-2">
        <div className="flex items-center gap-2 flex-wrap">
          <span
            className="px-2 py-0.5 text-xs font-bold font-['IBM_Plex_Sans']"
            style={{ backgroundColor: st.bgColor, color: st.color }}
          >
            {st.label}
          </span>
          <span className="text-sm font-bold font-['IBM_Plex_Sans'] text-[#0A0A0A]">
            {format(parseISO(mov.fecha_inicio), 'HH:mm')} - {format(parseISO(mov.fecha_fin), 'HH:mm')}
          </span>
          {hasConflictWithOther && (
            <span className="flex items-center gap-1 px-2 py-0.5 text-xs font-bold bg-[#FF3B30]/10 text-[#FF3B30] font-['IBM_Plex_Sans']">
              <Warning size={12} weight="bold" /> Conflicto
            </span>
          )}
        </div>
      </div>
      <p className="text-sm font-medium font-['IBM_Plex_Sans'] text-[#0A0A0A]">
        {mov.area} · {mov.num_personas} personas
      </p>
      <p className="text-xs text-[#495057] font-['IBM_Plex_Sans'] mt-1">
        Responsable: {mov.responsable} · {mov.telefono_contacto}
      </p>
      {mov.vehiculo && (
        <p className="text-xs text-[#C1121F] font-['IBM_Plex_Sans'] mt-1 font-medium">
          {mov.vehiculo} · {mov.conductor}
        </p>
      )}
    </button>
  );
};

export const CalendarDayDetailDialog = ({ selectedDay, selectedDayMovs, onClose, onSelectMov }) => (
  <Dialog open={!!selectedDay} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-w-2xl bg-white border border-[#E9ECEF] max-h-[90vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle className="text-2xl font-black font-['Chivo'] tracking-tight text-[#0A0A0A] capitalize">
          {selectedDay && format(selectedDay, "EEEE, d 'de' MMMM 'de' yyyy", { locale: es })}
        </DialogTitle>
        <DialogDescription className="text-[#495057] font-['IBM_Plex_Sans']">
          {selectedDayMovs.length === 0
            ? 'No hay movilizaciones programadas para este día'
            : `${selectedDayMovs.length} movilización(es) programada(s)`}
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-3 mt-4">
        {selectedDayMovs.map((mov) => {
          const hasConflictWithOther = selectedDayMovs.some(
            (other) => other.id !== mov.id && overlap(mov, other)
          );
          return (
            <MovRow
              key={mov.id}
              mov={mov}
              hasConflictWithOther={hasConflictWithOther}
              onSelect={onSelectMov}
            />
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);
